module.exports = __webpack_public_path__ + "img/cg5.88125582.jpg";